(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,8813,6510],{

/***/ 26518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ContentfulContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/** @public */
var ContentfulContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/** @public */
var ContentfulProvider = function (_a) {
    var contentful = _a.contentful, children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentfulContext.Provider, { value: contentful }, children);
};
ContentfulProvider.displayName = 'ContentfulProvider';
ContentfulContext.displayName = 'ContentfulContext';
/* harmony default export */ __webpack_exports__["Z"] = (ContentfulProvider);
//# sourceMappingURL=ContentfulProvider.js.map

/***/ }),

/***/ 21643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports FeatureContext, FeatureConsumer */
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded=["features"];var FeatureContext=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();var FeatureConsumer=FeatureContext.Consumer;var FeatureProvider=function FeatureProvider(_ref){var features=_ref.features,props=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref,_excluded);return/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FeatureContext.Provider,(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({value:features},props));};FeatureProvider.defaultProps={features:[]};FeatureProvider.propTypes={features:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)};/* harmony default export */ __webpack_exports__["ZP"] = (FeatureProvider);
//# sourceMappingURL=FeatureProvider.js.map

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(14602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMobilePromobarsExperiment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92654);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16510);
/* harmony import */ var _useAppBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7598);





var AppBannerAboveHeaderWithExperiment = function(param) {
    var content = param.content;
    var showAppBanner = (0,_useAppBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var isMobilePromoSETI = (0,_hooks_useMobilePromobarsExperiment__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var showAppBannerAboveHeader = !isMobilePromoSETI;
    return showAppBanner && showAppBannerAboveHeader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__["default"], {
        content: content
    }) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (AppBannerAboveHeaderWithExperiment);


/***/ }),

/***/ 71151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27204);


var _obj;
var BANNER_TEXT_VALUES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_1__/* .FLIGHT_PRODUCT_TYPE */ .oP, {
    titleText: "Get the app. Save more.",
    contentText: "Save up to 40% on flights with the app",
    pageId: "MWEB_FLT_HP_HEADER"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_1__/* .HOME_PRODUCT_TYPE */ .Wn, {
    titleText: "Get the app. Save more.",
    contentText: "Get exclusive deals only in our app",
    pageId: "MWEB_HTL_HP_HEADER"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_1__/* .HOTEL_PRODUCT_TYPE */ .kd, {
    titleText: "Get the app. Save more.",
    contentText: "Save up to 60% off hotels with the app",
    pageId: "MWEB_HTL_HP_HEADER"
}), _obj);
/* harmony default export */ __webpack_exports__["Z"] = (BANNER_TEXT_VALUES);


/***/ }),

/***/ 16510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AppBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/components/AppBanner/utils.ts
var utils = __webpack_require__(41167);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils_utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(39997);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ChevronRight.js
var ChevronRight = __webpack_require__(32680);
;// CONCATENATED MODULE: ./src/components/AppBanner/AppBannerSquareEdges.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background-color: #002f6b;\n  color: ",
        ";\n  padding: 10px;\n  @media (min-width: 400px) {\n    padding-right: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  &:active,\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var COOKIE_MAX_AGE = 86400 // 24 hours
;
var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f488d425-0"
})(_templateObject(), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-f488d425-1"
})(_templateObject1(), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var AppIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "57",
        height: "57",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
            width: "57",
            height: "57",
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAByCAMAAAC4A3VPAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACtVBMVEUAAAAAqv8AeP8Aef8A d/8AeP8AeP8AeP8AeP8Amf8Ad/8Ad/8Ad/8Ajv8AeP8Aef8AeP8Aev8AeP8A//8Aef8AgP8AeP8A eP8Ad/8Ad/8AeP8Ae/8AeP8Ad/8Fef8Yg/8SgP+YyP+52f9Sov86lf////+92/8Hev+Iv/+82/9p r/+kzv/8/f8ojP+Au/9Inf/T5/9To/+v1P93tv/r9P8Ugf9cqP/4+/8rjf90tP8dhv9Cmv92tf8p jP8Wgv8wkP9iq/9HnP8Mff89l/8CeP8xkf8tj/8LfP8DeP8+mP+Nwv+DvP8Ie/8hiP9xs/+SxP+j zf+Lwf9Qof8Eef8kiv8vkP8chf9jq/96uP9Bmf9tsf+RxP+Owv9VpP8Gev+byf+w1P/1+f9krP80 kv+p0f/l8f+72v9Amf/Y6v/s9P9eqf8Ofv+gzP/j8P+Vxv9WpP94t//7/P/B3f8Pf/8KfP/+/v/o 8v+Fvf/5+//6/P/a6/8Je//F4P+Uxf+Mwf/9/f9Uo/+y1f9fqf+Pw//e7f/k8P+Txf+Xx//y+P+E vf/b6/9Em/+JwP/J4v/A3f/V6P9ztP/i7/9orv9Dmv+CvP/3+v8Vgv+lz/8Bd/+hzP8eh/9wsv/g 7v8qjf+q0f/z+P/u9f98uf9vsv/p8/8fh/8ni/8Tgf9mrf9Ln/+izf8bhf85lf+42f/2+v8sjv/H 4f8zkv/L4//n8v9usf9dqP/W6f+z1v8ahP/D3/9+uv/f7f/I4f+u0/8RgP/0+f+cyv9gqv+t0/8g iP9Zpv91tf+ayf+ey//X6f9ap//N5P81k/99uf/Z6v9Fm//U6P/t9f9GnP/M4/+Gvv8ZhP/w9/+s 0v+32P/G4P+o0P95t/8uj/8mi/9Jnf+Qw/9/uv9hqv9Knv+n0P/R5v++3P+Bu/84lP/Q5f+v8YJH AAAAHXRSTlMAAzVymsLf7PkFT6vwCXlj5EnVAYUMsCDS6aw2m/ImqpAAAAABYktHRCXDAckPAAAA B3RJTUUH5AUTDyklz1OIpAAABPBJREFUaN7tm4tbFFUUwGd3gcUFAXmpwGFVvFEGYlHaQwhiVQQl ZXmYGVmGkZaGgEKWlEZiJZWlkRqSmZZZGj3NB2CW9i572mt7/x2de2cfw+5l4MOZud/nN+f7ds65 95yd38yde8/sfnNGkjhisdrCwiPskTBiibRHhIfZrBZpWDLKERU9ctZAiY5yjBoSODrGrhVPFnvM aFWgJTZOWyCVuFiV8R0Trz2QSvyYQYAJifoAqSQm8IhJyfoRAZKTQoljx+lJBBg3NoQ4Xl8iwPgg ZpLO58jOc8DYJuh6HX2SrJxDOs5VpSQq1qMxRAD/+rTolAFCJd6Xh2KNIgLEejO5Dnl1MImTc3yM cUSAGHZ/1PhupS52ev90GEkEcCAyxVhkFK4QzX51DE+iLVKqsUQAq2QzGmmT0oxGpknhRiPDpQij kRGSoYmAil26gH8BI5NIyWgigIk0kSbSRJpIE2kiL1ZkutPpnKAtcsLESRlq/smEkEsAMi+9bIpW yMsJycoeGjkVVY5GyGm4ryuGRl6JKlcjJB7+VVcPjZxOyIxrNEJCxrXXqbm9SLh+5rCISmReXl4+ 3FCQW8im341FRUXZ4Jo1G2ajNYd2Fc/NLSnNmMeC55fdtGBhuVuBrMAwHIxKFKiqLl10s0vebdXi WxYsubWGi8Rv3rYUN+T2O7C1DI07p9eSEliOViX23FVHneTuFQAr72EmuXduALkK1WqALFT31VPn mgZ0Nq5qYpFrCwdBym5C1snIZvz4kTktXuf989Y/4DVJfY4f+WAA6ZUNuGYn+RqtD/GRhDy8cROC WioYkiiQNY+gant0c3vTLNiC5mPVjz+BB9HWwDnLrK0d9DyfBHgK1dPbnnl2O47ODj7yuU6AKaif l5FtC1fv9CJ34XZ3PsALXdC4h5BuNOFF7NvGQe5l85d0g/slvEz7MHIxNmfykS+jTm+nB0iR7ftp v4zswO0B2qyBV9B89SDKa2gc4iBxFqXjNXqduZbSyDfQOMxFdjNjDa4w1xFsvgkBZA9uq+TAt4hC aoOuJY5oEw1qpsi3lZF7uMh3mPEuWu9R5PsB5Bz6pWI5cJNyR6Q45Czr/cijAyIbeMgPmHEMDzQz COmmk9kpB5agebzaJ+6Qswwg6cU+5I9cz0O2nqBJ4CQuIwhCQi1uV8iBZWj2Mis7AziLJIDsw75+ FnnqQ9cgi6QU9WnUH7Hpo0R+jNszeEQrz0IlTRc70ZN5mHySAyoDuw/HpiUPW+7lZFo5H5m1pHxD K+plIchPaXfdZ3s/78mEfjR7dn1x4EvUR9WQ0IudX53+uvobOTNwU4EsXRAysHDO55wI337nj/ze BSrXEk6s9Uf+kM5PeD8y70+NHCScb2bOGec64eet8m5OlhWDKhJ+6ZAjty/yEYOnD/z6W+/vR2hr v8fj+YP1F6LFbi5V5/881j/1IDVdnuN/nfn7H5pYIB/9mGr/RXUKoK+goI/2bvR42GzrPNv1X13H uooAJxhpgJhI/ZH4C9hpMNIoMZEm0kSaSBN5cSEFPIAS8JhNwMNEAY9MDX8wHCbi8bfVaKRVRCmD gIINEWUpAopvBJQYiSikElAuJqIoTkDpn4gCRxFlnAKKVUWU5IooPBZRXi2iiFwSUCoviXghQBLw 2gMrXnWkaPdyR8owXu6QxzfVlnbhr7Ck2VK5I/o/Z+dDnvYkUfwAAAAldEVYdGRhdGU6Y3JlYXRl ADIwMjAtMDUtMTlUMTU6NDE6MzcrMDM6MDDubfKPAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA1 LTE5VDE1OjQxOjM3KzAzOjAwnzBKMwAAAABJRU5ErkJggg=="
        })
    });
};
function AppBanner(param) {
    var isAndroid = param.isAndroid, titleText = param.titleText, contentText = param.contentText, pageId = param.pageId, referral = param.referral, clientGUID = param.clientGUID;
    var ref = (0,react.useState)(true), isBannerVisible = ref[0], setBannerVisible = ref[1];
    var closeAppBanner = function() {
        setBannerVisible(false);
        document.cookie = "hideAppBanner=true; domain=.priceline.com; path=/; max-age=".concat(COOKIE_MAX_AGE, ";");
    };
    return isBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        id: "app-download-banner",
        className: "app-banner",
        fontSize: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                    size: 16,
                    id: "closeBannerBtn",
                    "data-ga-category": "PCLN_HOME",
                    "data-ga-action": "App_Banner",
                    "data-ga-label": "dismiss",
                    title: "dismiss app banner",
                    onClick: closeAppBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                color: "text.lightest",
                href: (0,utils/* getLink */.Rg)(isAndroid, referral, clientGUID, "".concat(pageId, "_v1")),
                "data-testid": "DASH_MWEB_TAB_GET_APP",
                "data-ga-category": "PCLN_HOME",
                "data-ga-action": "App_Banner",
                "data-ga-label": "click to launch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "flex-start",
                        px: 12,
                        py: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontWeight: "bold",
                                fontSize: 15,
                                lineHeight: "19px",
                                mb: 1,
                                children: titleText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontSize: 13,
                                lineHeight: "12px",
                                children: contentText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        ml: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                            title: "click to launch app",
                            color: "text.lightest",
                            size: 20
                        })
                    })
                ]
            })
        ]
    }) : null;
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowRight.js
var ArrowRight = __webpack_require__(91209);
;// CONCATENATED MODULE: ./src/components/AppBanner/AppBannerRounded.tsx




function AppBannerRounded_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: rgb(0 0 0 / 24%) 0px 0px 1px 0px,\n    rgb(0 0 0 / 16%) 0px 2px 1px -1px, rgb(0 0 0 / 12%) 0px 2px 4px 0px;\n"
    ]);
    AppBannerRounded_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AppBannerRounded_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  &:active,\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    AppBannerRounded_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var AppBannerRounded_Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6e5e6d92-0"
})(AppBannerRounded_templateObject());
var AppBannerRounded_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-6e5e6d92-1"
})(AppBannerRounded_templateObject1(), (0,utils_utils/* getPaletteColor */.ow)("text.lightest"));
var AppBannerRounded_AppIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "72",
        height: "72",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
            width: "72",
            height: "72",
            xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAAByCAMAAAC4A3VPAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACtVBMVEUAAAAAqv8AeP8Aef8A d/8AeP8AeP8AeP8AeP8Amf8Ad/8Ad/8Ad/8Ajv8AeP8Aef8AeP8Aev8AeP8A//8Aef8AgP8AeP8A eP8Ad/8Ad/8AeP8Ae/8AeP8Ad/8Fef8Yg/8SgP+YyP+52f9Sov86lf////+92/8Hev+Iv/+82/9p r/+kzv/8/f8ojP+Au/9Inf/T5/9To/+v1P93tv/r9P8Ugf9cqP/4+/8rjf90tP8dhv9Cmv92tf8p jP8Wgv8wkP9iq/9HnP8Mff89l/8CeP8xkf8tj/8LfP8DeP8+mP+Nwv+DvP8Ie/8hiP9xs/+SxP+j zf+Lwf9Qof8Eef8kiv8vkP8chf9jq/96uP9Bmf9tsf+RxP+Owv9VpP8Gev+byf+w1P/1+f9krP80 kv+p0f/l8f+72v9Amf/Y6v/s9P9eqf8Ofv+gzP/j8P+Vxv9WpP94t//7/P/B3f8Pf/8KfP/+/v/o 8v+Fvf/5+//6/P/a6/8Je//F4P+Uxf+Mwf/9/f9Uo/+y1f9fqf+Pw//e7f/k8P+Txf+Xx//y+P+E vf/b6/9Em/+JwP/J4v/A3f/V6P9ztP/i7/9orv9Dmv+CvP/3+v8Vgv+lz/8Bd/+hzP8eh/9wsv/g 7v8qjf+q0f/z+P/u9f98uf9vsv/p8/8fh/8ni/8Tgf9mrf9Ln/+izf8bhf85lf+42f/2+v8sjv/H 4f8zkv/L4//n8v9usf9dqP/W6f+z1v8ahP/D3/9+uv/f7f/I4f+u0/8RgP/0+f+cyv9gqv+t0/8g iP9Zpv91tf+ayf+ey//X6f9ap//N5P81k/99uf/Z6v9Fm//U6P/t9f9GnP/M4/+Gvv8ZhP/w9/+s 0v+32P/G4P+o0P95t/8uj/8mi/9Jnf+Qw/9/uv9hqv9Knv+n0P/R5v++3P+Bu/84lP/Q5f+v8YJH AAAAHXRSTlMAAzVymsLf7PkFT6vwCXlj5EnVAYUMsCDS6aw2m/ImqpAAAAABYktHRCXDAckPAAAA B3RJTUUH5AUTDyklz1OIpAAABPBJREFUaN7tm4tbFFUUwGd3gcUFAXmpwGFVvFEGYlHaQwhiVQQl ZXmYGVmGkZaGgEKWlEZiJZWlkRqSmZZZGj3NB2CW9i572mt7/x2de2cfw+5l4MOZud/nN+f7ds65 95yd38yde8/sfnNGkjhisdrCwiPskTBiibRHhIfZrBZpWDLKERU9ctZAiY5yjBoSODrGrhVPFnvM aFWgJTZOWyCVuFiV8R0Trz2QSvyYQYAJifoAqSQm8IhJyfoRAZKTQoljx+lJBBg3NoQ4Xl8iwPgg ZpLO58jOc8DYJuh6HX2SrJxDOs5VpSQq1qMxRAD/+rTolAFCJd6Xh2KNIgLEejO5Dnl1MImTc3yM cUSAGHZ/1PhupS52ev90GEkEcCAyxVhkFK4QzX51DE+iLVKqsUQAq2QzGmmT0oxGpknhRiPDpQij kRGSoYmAil26gH8BI5NIyWgigIk0kSbSRJpIE2kiL1ZkutPpnKAtcsLESRlq/smEkEsAMi+9bIpW yMsJycoeGjkVVY5GyGm4ryuGRl6JKlcjJB7+VVcPjZxOyIxrNEJCxrXXqbm9SLh+5rCISmReXl4+ 3FCQW8im341FRUXZ4Jo1G2ajNYd2Fc/NLSnNmMeC55fdtGBhuVuBrMAwHIxKFKiqLl10s0vebdXi WxYsubWGi8Rv3rYUN+T2O7C1DI07p9eSEliOViX23FVHneTuFQAr72EmuXduALkK1WqALFT31VPn mgZ0Nq5qYpFrCwdBym5C1snIZvz4kTktXuf989Y/4DVJfY4f+WAA6ZUNuGYn+RqtD/GRhDy8cROC WioYkiiQNY+gant0c3vTLNiC5mPVjz+BB9HWwDnLrK0d9DyfBHgK1dPbnnl2O47ODj7yuU6AKaif l5FtC1fv9CJ34XZ3PsALXdC4h5BuNOFF7NvGQe5l85d0g/slvEz7MHIxNmfykS+jTm+nB0iR7ftp v4zswO0B2qyBV9B89SDKa2gc4iBxFqXjNXqduZbSyDfQOMxFdjNjDa4w1xFsvgkBZA9uq+TAt4hC aoOuJY5oEw1qpsi3lZF7uMh3mPEuWu9R5PsB5Bz6pWI5cJNyR6Q45Czr/cijAyIbeMgPmHEMDzQz COmmk9kpB5agebzaJ+6Qswwg6cU+5I9cz0O2nqBJ4CQuIwhCQi1uV8iBZWj2Mis7AziLJIDsw75+ FnnqQ9cgi6QU9WnUH7Hpo0R+jNszeEQrz0IlTRc70ZN5mHySAyoDuw/HpiUPW+7lZFo5H5m1pHxD K+plIchPaXfdZ3s/78mEfjR7dn1x4EvUR9WQ0IudX53+uvobOTNwU4EsXRAysHDO55wI337nj/ze BSrXEk6s9Uf+kM5PeD8y70+NHCScb2bOGec64eet8m5OlhWDKhJ+6ZAjty/yEYOnD/z6W+/vR2hr v8fj+YP1F6LFbi5V5/881j/1IDVdnuN/nfn7H5pYIB/9mGr/RXUKoK+goI/2bvR42GzrPNv1X13H uooAJxhpgJhI/ZH4C9hpMNIoMZEm0kSaSBN5cSEFPIAS8JhNwMNEAY9MDX8wHCbi8bfVaKRVRCmD gIINEWUpAopvBJQYiSikElAuJqIoTkDpn4gCRxFlnAKKVUWU5IooPBZRXi2iiFwSUCoviXghQBLw 2gMrXnWkaPdyR8owXu6QxzfVlnbhr7Ck2VK5I/o/Z+dDnvYkUfwAAAAldEVYdGRhdGU6Y3JlYXRl ADIwMjAtMDUtMTlUMTU6NDE6MzcrMDM6MDDubfKPAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA1 LTE5VDE1OjQxOjM3KzAzOjAwnzBKMwAAAABJRU5ErkJggg=="
        })
    });
};
function AppBannerRounded_AppBanner(_param) {
    var isAndroid = _param.isAndroid, titleText = _param.titleText, contentText = _param.contentText, pageId = _param.pageId, referral = _param.referral, clientGUID = _param.clientGUID, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isAndroid",
        "titleText",
        "contentText",
        "pageId",
        "referral",
        "clientGUID"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBannerRounded_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        py: 2,
        pl: 2,
        pr: 12,
        id: "app-download-banner",
        className: "app-banner",
        fontSize: 0,
        borderRadius: "xl",
        bg: (0,utils_utils/* getPaletteColor */.ow)("primary.shade"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBannerRounded_StyledLink, {
            color: "text.lightest",
            /**
         * TODO: HP_LP_MBL_PROMOBARS seti Cleanup:
         * remove addition of '_v2' from pageId once seti HP_LP_MBL_PROMOBARS declared.
         * v2 was added to distinguish the new addBanner placement (ie the rounded promo bar) for VARIANT
         * */ href: (0,utils/* getLink */.Rg)(isAndroid, referral, clientGUID, "".concat(pageId, "_v2")),
            "data-testid": "DASH_MWEB_TAB_GET_APP",
            "data-ga-category": "PCLN_HOME",
            "data-ga-action": "App_Banner",
            "data-ga-label": "click to launch",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    alignItems: "flex-start",
                    pl: 0,
                    pr: 12,
                    py: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBannerRounded_AppIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            textStyle: "heading6",
                            mb: 1,
                            children: titleText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            textStyle: "caption",
                            children: contentText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    alignItems: "center",
                    ml: "auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {
                        title: "click to launch app",
                        color: "text.lightest",
                        size: 20
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/AppBanner/index.tsx








var AppBannerWrapper = function(_param) {
    var content = _param.content, _isRoundedBanner = _param.isRoundedBanner, isRoundedBanner = _isRoundedBanner === void 0 ? false : _isRoundedBanner, props = (0,_object_without_properties/* default */.Z)(_param, [
        "content",
        "isRoundedBanner"
    ]);
    var bootstrapData = (0,react.useContext)(BootstrapDataContext/* default */.Z);
    var AppBannerComponent = isRoundedBanner ? AppBannerRounded_AppBanner : AppBanner;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBannerComponent, (0,_object_spread/* default */.Z)({}, (0,utils/* getPropsForAppBanner */.we)(bootstrapData), content, props));
};
/* harmony default export */ var components_AppBanner = (AppBannerWrapper);


/***/ }),

/***/ 7598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68464);
/* harmony import */ var _shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41811);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41167);





var useAppBanner = function() {
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query;
    var bootstrapData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    var isCookieSetToHideAppBanner = bootstrapData.isCookieSetToHideAppBanner, _isMobile = bootstrapData.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, referral = bootstrapData.referral;
    var ref = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTrafficInfo */ .aY)(query, referral), isPaid = ref.isPaid, isBranded = ref.isBranded, isBlackListed = ref.isBlackListed;
    var hideAppBanner = isCookieSetToHideAppBanner || (0,_shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(query) || !isMobile || isPaid && !isBranded || isBlackListed;
    var showAppBanner = !hideAppBanner;
    return showAppBanner;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppBanner);


/***/ }),

/***/ 41167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "aY": function() { return /* binding */ getTrafficInfo; },
/* harmony export */   "we": function() { return /* binding */ getPropsForAppBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69376);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57330);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58493);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72593);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24088);


var buildReferralData = function(isAndroid, referral) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        sourceId: "",
        id: "DTAPPDL",
        clickId: isAndroid ? "MWEBHPANDROID" : "MWEBHPIOS"
    }, referral);
};
var baseUrlAndroid = "https://www.priceline.com/r/app/";
var baseUrlNoAndroid = "https://offers.priceline.com/lrapp/";
var getLink = function(isAndroid, referral, clientGUID, pageId) {
    var ref = buildReferralData(isAndroid, referral), id = ref.id, sourceId = ref.sourceId, _clickId = ref.clickId, clickId = _clickId === void 0 ? "" : _clickId;
    var queryStringObject = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        channel: "Display",
        product: "App",
        theme: "app_dl_install",
        refid: "".concat(sourceId).concat(id),
        refclickid: clickId,
        PAGEID: pageId
    }, clientGUID && {
        subSiteId: clientGUID
    });
    var baseUrl = isAndroid ? baseUrlAndroid : baseUrlNoAndroid;
    return (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseUrl, "?"), (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("&", (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("="), (0,ramda__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(queryStringObject))));
};
var getTrafficInfo = function(query, referral) {
    var tmp = referral.id, _ckReferralId = tmp === void 0 ? "" : tmp, tmp1 = referral.clickId, cookieRefClickId = tmp1 === void 0 ? "" : tmp1, tmp2 = referral.sourceId, _ckRefSourceId = tmp2 === void 0 ? "" : tmp2;
    var cookieRefId = _ckRefSourceId.concat(_ckReferralId);
    var tmp3 = query.refid, _qsRefId = tmp3 === void 0 ? "" : tmp3, tmp4 = query.refclickid, _qsRefClickId = tmp4 === void 0 ? "" : tmp4;
    var queryRefId = typeof _qsRefId === "string" && Object.keys(_qsRefId).length > 0 ? _qsRefId : "";
    var queryRefClickId = typeof _qsRefClickId === "string" && Object.keys(_qsRefClickId).length > 0 ? _qsRefClickId : "";
    var isPaid = cookieRefId.indexOf("GOOGLECPC|MSN") > -1 || queryRefId.indexOf("GOOGLECPC|MSN") > -1;
    var isBranded = cookieRefClickId.indexOf("BRAND") > -1 || queryRefClickId.indexOf("BRAND") > -1;
    var excludedRefIds = [
        "PLHTLCOMBINED",
        "PLHBC10161OPQ"
    ];
    var isBlackListed = cookieRefId.indexOf("CO") === 0 || queryRefId.indexOf("CO") === 0 || excludedRefIds.indexOf(cookieRefId) > -1 || excludedRefIds.indexOf(queryRefId) > -1;
    return {
        isPaid: isPaid,
        isBranded: isBranded,
        isBlackListed: isBlackListed
    };
};
var getPropsForAppBanner = function(data) {
    var referral = data.referral, webstats = data.webstats, isMobile = data.isMobile, isAndroid = data.isAndroid;
    var ref;
    return {
        referral: referral !== null && referral !== void 0 ? referral : {},
        clientGUID: (ref = webstats === null || webstats === void 0 ? void 0 : webstats.clientGUID) !== null && ref !== void 0 ? ref : "",
        isMobile: isMobile,
        isAndroid: isAndroid
    };
};


/***/ }),

/***/ 38704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TmsScript; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/constants/path-map.ts
var pathMap = {
    "/": "home",
    "/home": "home",
    "/home/": "home",
    "/hotels": "hotels",
    "/hotels/": "hotels",
    "/vacationpackages": "packages",
    "/vacationpackages/": "packages",
    "/flights": "flights",
    "/flights/": "flights",
    "/insideTrack/flights": "flights"
};
function normalizePath(path) {
    if (path.startsWith("/insideTrack/flights")) {
        return "/insideTrack/flights";
    }
    return path;
}
function isValidPath(path) {
    return pathMap[normalizePath(path)] !== undefined;
}
/**
 *
 * inside track paths are actually formed like /insideTrack/flights/from_New_York_City-NYC.html
 * so this param is cheating a little
 */ function mapPath(path) {
    return pathMap[normalizePath(path)];
};

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/TmsScript/useTmsConfig.ts





var ProductIds = {
    hotels: 5,
    flights: 1,
    packages: 17,
    home: 16
};
function useTmsConfig(pathname) {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), isMobile = ref.isMobile, referral = ref.referral, seti = ref.seti, webstats = ref.webstats, sha2e = ref.sha2e, _vipTier = ref.vipTier, vipTier = _vipTier === void 0 ? "" : _vipTier;
    if (!isValidPath(pathname)) {
        return null;
    }
    var _clickId = referral.clickId, clickId = _clickId === void 0 ? "" : _clickId, _id = referral.id, id = _id === void 0 ? "" : _id, _sourceId = referral.sourceId, sourceId = _sourceId === void 0 ? "" : _sourceId;
    var firstTimeHere = webstats.firstTimeHere, startOfVisit = webstats.startOfVisit;
    var tmsData = {
        appCode: isMobile ? "MOBILEWEB" : "DESKTOP",
        sha2e: sha2e,
        refId: sourceId + id,
        refClickId: clickId,
        SETI: seti,
        firstTimeHere: firstTimeHere,
        startOfVisit: startOfVisit,
        vipTier: vipTier || "NONE",
        vipMember: vipTier ? "Yes" : "No"
    };
    var product = mapPath(pathname);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tmsData), {
        pageType: product === "home" ? "hp" : "prodhp",
        productId: ProductIds[product]
    });
};

;// CONCATENATED MODULE: ./src/components/TmsScript/TmsScript.tsx




function TmsScript(param) {
    var pathname = param.pathname;
    var tmsConfig = useTmsConfig(pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "pclntms-script",
        strategy: "afterInteractive",
        src: "/svcs/mkt/tag/pclntms.js",
        onLoad: function() {
            if (window.pclntms) {
                window.pclntms.push(tmsConfig);
            }
        }
    });
};


/***/ }),

/***/ 27204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jz": function() { return /* binding */ RENTAL_CAR_PRODUCT_TYPE; },
/* harmony export */   "Pz": function() { return /* binding */ BUNDLE_AND_SAVE_PRODUCT_TYPE; },
/* harmony export */   "Wn": function() { return /* binding */ HOME_PRODUCT_TYPE; },
/* harmony export */   "ZE": function() { return /* binding */ CRUISE_PRODUCT_TYPE; },
/* harmony export */   "kd": function() { return /* binding */ HOTEL_PRODUCT_TYPE; },
/* harmony export */   "nu": function() { return /* binding */ VACATION_PACKAGE_PRODUCT_TYPE; },
/* harmony export */   "oP": function() { return /* binding */ FLIGHT_PRODUCT_TYPE; }
/* harmony export */ });
/* unused harmony export TRIPS_PRODUCT_TYPE */
var CRUISE_PRODUCT_TYPE = "cruises";
var FLIGHT_PRODUCT_TYPE = "flights";
var HOME_PRODUCT_TYPE = "home";
var HOTEL_PRODUCT_TYPE = "hotels";
var RENTAL_CAR_PRODUCT_TYPE = "cars";
var TRIPS_PRODUCT_TYPE = "trips";
var VACATION_PACKAGE_PRODUCT_TYPE = "packages";
var BUNDLE_AND_SAVE_PRODUCT_TYPE = "bundle + save";


/***/ }),

/***/ 8176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useGA4AnalyticsForSETI; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/analytics/dist/esm/browser.js + 22 modules
var browser = __webpack_require__(45741);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/constants/page-map.ts
var pageMap = {
    "/": "homepage",
    "/hotels": "landingpage",
    "/flights": "landingpage",
    "/vacationpackages": "landingpage",
    "/vip": "vip"
};
function mapPage(page) {
    return pageMap[page];
};

;// CONCATENATED MODULE: ./src/constants/product-map.ts
var productMap = {
    "/": "",
    "/hotels": "hotel",
    "/flights": "air",
    "/vacationpackages": "bundle",
    "/vip": "",
    vacations: "bundle",
    hotels: "hotel",
    flights: "air",
    cars: "car",
    cruises: "cruise"
};
function mapProduct(product) {
    return productMap[product];
};

;// CONCATENATED MODULE: ./src/hooks/useRouteInfo.ts



function useRouteInfo() {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var pageName = mapPage(pathname);
    var currentTab = (query === null || query === void 0 ? void 0 : query.tab) && !Array.isArray(query.tab) ? query.tab : undefined;
    var productName = currentTab ? mapProduct(currentTab) : mapProduct(pathname);
    return {
        pageName: pageName,
        productName: productName
    };
};

;// CONCATENATED MODULE: ./src/hooks/useGA4Analytics.ts




function isSuccessfulSetiResponse(fullSeti) {
    return fullSeti.length === 0 || fullSeti[0].setiID !== undefined && fullSeti[0].setiVariantID !== undefined;
}
function useGA4AnalyticsForSETI(experimentCode) {
    var fullSETI = (0,react.useContext)(BootstrapDataContext/* default */.Z).fullSETI;
    var routeInfo = useRouteInfo();
    var logGA4Event = (0,react.useCallback)(function() {
        var baseSETI;
        if (isSuccessfulSetiResponse(fullSETI)) baseSETI = fullSETI.find(function(seti) {
            return seti.setiTagName === experimentCode;
        });
        if (!(baseSETI === null || baseSETI === void 0 ? void 0 : baseSETI.setiID)) return;
        browser/* default.GA4Enabled */.Z.GA4Enabled = true;
        browser/* default.logEvent */.Z.logEvent({
            event: "seti",
            attributes: {
                seti_id: baseSETI.setiID,
                seti_variant_id: baseSETI.setiVariantID,
                seti_name: experimentCode,
                page_name: routeInfo.pageName,
                product_name: routeInfo.productName
            }
        });
        browser/* default.GA4Enabled */.Z.GA4Enabled = false;
    }, [
        experimentCode,
        fullSETI,
        routeInfo
    ]);
    return {
        logGA4Event: logGA4Event
    };
};


/***/ }),

/***/ 92654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);
/* harmony import */ var _hooks_useSeti__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39939);



var useMobilePromobarsExperiment = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var isMobilePromoSETI = (0,_hooks_useSeti__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("HP_LP_MBL_PROMOBARS", isMobile) === "VARIANT";
    return isMobilePromoSETI;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobilePromobarsExperiment);


/***/ }),

/***/ 39939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSeti; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80460);
/* harmony import */ var _context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68374);
/* harmony import */ var _useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8176);




function useSeti(experimentCode) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), tmp = ref[experimentCode], setiTest = tmp === void 0 ? "DEFAULT" : tmp;
    var logGA4Event = (0,_useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(experimentCode).logGA4Event;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (experimentCode && shouldFireImpression) {
            _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireImpression */ .Z.fireImpression(experimentCode);
            logGA4Event();
        }
    }, [
        experimentCode,
        logGA4Event,
        shouldFireImpression
    ]);
    return setiTest;
};


/***/ }),

/***/ 14602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulProvider/ContentfulProvider.js
var ContentfulProvider = __webpack_require__(26518);
// EXTERNAL MODULE: ./node_modules/@pcln/feature-components/dist/esm/FeatureProvider/FeatureProvider.js
var FeatureProvider = __webpack_require__(21643);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 11 modules
var Layout = __webpack_require__(78259);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
;// CONCATENATED MODULE: ./src/components/Home/index.tsx






var HomeDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3525), __webpack_require__.e(7713), __webpack_require__.e(9956), __webpack_require__.e(2049), __webpack_require__.e(6722), __webpack_require__.e(4280), __webpack_require__.e(1713), __webpack_require__.e(370), __webpack_require__.e(8680), __webpack_require__.e(4193), __webpack_require__.e(9637), __webpack_require__.e(6177), __webpack_require__.e(6330), __webpack_require__.e(8916), __webpack_require__.e(6229), __webpack_require__.e(3292), __webpack_require__.e(3470), __webpack_require__.e(7151), __webpack_require__.e(4321)]).then(__webpack_require__.bind(__webpack_require__, 64321));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64321)
            ];
        }
    }
});
var HomeMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3525), __webpack_require__.e(7713), __webpack_require__.e(9956), __webpack_require__.e(2049), __webpack_require__.e(6722), __webpack_require__.e(4280), __webpack_require__.e(1713), __webpack_require__.e(4193), __webpack_require__.e(6177), __webpack_require__.e(6330), __webpack_require__.e(8916), __webpack_require__.e(6229), __webpack_require__.e(3292), __webpack_require__.e(7151), __webpack_require__.e(4249)]).then(__webpack_require__.bind(__webpack_require__, 34249));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34249)
            ];
        }
    }
});
function Home() {
    (0,useSeti/* default */.Z)("AA_HOMEPAGE") // AA Test: Unconditional firing and no visual changes
    ;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDesktop, {})
    });
};

// EXTERNAL MODULE: ./src/components/AppBanner/constants.ts
var constants = __webpack_require__(71151);
// EXTERNAL MODULE: ./src/constants/products.ts
var products = __webpack_require__(27204);
// EXTERNAL MODULE: ./src/components/AppBanner/AppBannerAboveHeaderWithExperiment.tsx
var AppBannerAboveHeaderWithExperiment = __webpack_require__(48813);
// EXTERNAL MODULE: ./src/components/TmsScript/TmsScript.tsx + 2 modules
var TmsScript = __webpack_require__(38704);
;// CONCATENATED MODULE: ./src/pages/index.tsx











var Homepage = function(param) {
    var headerHTML = param.headerHTML, footerHTML = param.footerHTML, bootstrapData = param.bootstrapData, content = param.content;
    var pathname = (0,router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TmsScript/* default */.Z, {
                pathname: pathname
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureProvider/* default */.ZP, {
                features: bootstrapData.featureToggles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentfulProvider/* default */.Z, {
                    contentful: content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBannerAboveHeaderWithExperiment["default"], {
                            content: constants/* default */.Z[products/* HOME_PRODUCT_TYPE */.Wn]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                            headerHTML: headerHTML,
                            footerHTML: footerHTML,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Homepage);


/***/ }),

/***/ 41811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLoadedInAppView; }
/* harmony export */ });
function isLoadedInAppView(query) {
    var NEGOTIATORAPP = query.NEGOTIATORAPP, negotiatorapp = query.negotiatorapp;
    return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined;
};


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 39997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8690);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75271);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14649);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var propTypes = {
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
};
var CloseButton = function (props) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, __assign({}, props, { icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(pcln_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { size: props.size }) }))); };
CloseButton.defaultProps = {
    size: 24,
    title: 'close',
};
CloseButton.propTypes = {};
CloseButton.displayName = 'CloseButton';
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);
//# sourceMappingURL=CloseButton.js.map

/***/ }),

/***/ 91209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 4l-1.4 1.4 5.6 5.6H4v2h12.2l-5.6 5.6L12 20l8-8-8-8z"
  }));
};

var SvgArrowRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "ArrowRight__SvgArrowRight",
  componentId: "sc-vskjda-0"
})(["outline:none;"]);
SvgArrowRight.isIcon = true;
SvgArrowRight.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);

/***/ }),

/***/ 32680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6L8 16.6z"
  }));
};

var SvgChevronRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "ChevronRight__SvgChevronRight",
  componentId: "sc-189tolx-0"
})(["outline:none;"]);
SvgChevronRight.isIcon = true;
SvgChevronRight.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRight);

/***/ }),

/***/ 57330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _internal_curry2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81353);
/* harmony import */ var _internal_isArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5272);
/* harmony import */ var _internal_isFunction_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34893);
/* harmony import */ var _internal_isString_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53459);
/* harmony import */ var _toString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79241);





/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */

var concat =
/*#__PURE__*/
(0,_internal_curry2_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function concat(a, b) {
  if ((0,_internal_isArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(a)) {
    if ((0,_internal_isArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(b)) {
      return a.concat(b);
    }

    throw new TypeError((0,_toString_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(b) + ' is not an array');
  }

  if ((0,_internal_isString_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(a)) {
    if ((0,_internal_isString_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(b)) {
      return a + b;
    }

    throw new TypeError((0,_toString_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(b) + ' is not a string');
  }

  if (a != null && (0,_internal_isFunction_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }

  if (a != null && (0,_internal_isFunction_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(a.concat)) {
    return a.concat(b);
  }

  throw new TypeError((0,_toString_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});

/* harmony default export */ __webpack_exports__["Z"] = (concat);

/***/ }),

/***/ 72593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_map; }
});

// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_curry2.js
var _curry2 = __webpack_require__(81353);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_dispatchable.js + 1 modules
var _dispatchable = __webpack_require__(12155);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_map.js
var _map = __webpack_require__(17900);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_reduce.js + 3 modules
var _reduce = __webpack_require__(77682);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_xfBase.js
var _xfBase = __webpack_require__(35643);
;// CONCATENATED MODULE: ./node_modules/ramda/es/internal/_xmap.js



var XMap =
/*#__PURE__*/
function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XMap.prototype['@@transducer/init'] = _xfBase/* default.init */.Z.init;
  XMap.prototype['@@transducer/result'] = _xfBase/* default.result */.Z.result;

  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap =
/*#__PURE__*/
(0,_curry2/* default */.Z)(function _xmap(f, xf) {
  return new XMap(f, xf);
});

/* harmony default export */ var internal_xmap = (_xmap);
// EXTERNAL MODULE: ./node_modules/ramda/es/curryN.js + 1 modules
var curryN = __webpack_require__(42469);
// EXTERNAL MODULE: ./node_modules/ramda/es/keys.js
var keys = __webpack_require__(79898);
;// CONCATENATED MODULE: ./node_modules/ramda/es/map.js







/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */

var map =
/*#__PURE__*/
(0,_curry2/* default */.Z)(
/*#__PURE__*/
(0,_dispatchable/* default */.Z)(['fantasy-land/map', 'map'], internal_xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return (0,curryN/* default */.Z)(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });

    case '[object Object]':
      return (0,_reduce/* default */.Z)(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, (0,keys/* default */.Z)(functor));

    default:
      return (0,_map/* default */.Z)(fn, functor);
  }
}));

/* harmony default export */ var es_map = (map);

/***/ }),

/***/ 69376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_merge; }
});

// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_has.js
var _has = __webpack_require__(5537);
;// CONCATENATED MODULE: ./node_modules/ramda/es/internal/_objectAssign.js
 // Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

function _objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;

  while (idx < length) {
    var source = arguments[idx];

    if (source != null) {
      for (var nextKey in source) {
        if ((0,_has/* default */.Z)(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }

    idx += 1;
  }

  return output;
}

/* harmony default export */ var internal_objectAssign = (typeof Object.assign === 'function' ? Object.assign : _objectAssign);
// EXTERNAL MODULE: ./node_modules/ramda/es/internal/_curry2.js
var _curry2 = __webpack_require__(81353);
;// CONCATENATED MODULE: ./node_modules/ramda/es/merge.js


/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated since v0.26.0
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */

var merge =
/*#__PURE__*/
(0,_curry2/* default */.Z)(function merge(l, r) {
  return internal_objectAssign({}, l, r);
});

/* harmony default export */ var es_merge = (merge);

/***/ }),

/***/ 24088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _internal_curry1_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93993);
/* harmony import */ var _internal_has_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5537);


/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */

var toPairs =
/*#__PURE__*/
(0,_internal_curry1_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function toPairs(obj) {
  var pairs = [];

  for (var prop in obj) {
    if ((0,_internal_has_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }

  return pairs;
});

/* harmony default export */ __webpack_exports__["Z"] = (toPairs);

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5285,8493,5769,4098,8259,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);